export default __webpack_public_path__ + "static/media/The Narthex of Hell.a731dd6e.jpg";